import React from "react";
import logoTrawlpack from "./assets/images/logotb.png";
import { useMediaQuery } from "react-responsive";
const Head = (props) => {
  const isBigScreen = useMediaQuery({ query: "(min-width: 750px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 600px)" });
  return (
<div>
{isBigScreen &&
    <div className=" background-jasa-top-kargo">
      <a href="/" className="mb-100 m-auto">
        <img className="w-60 mb-55" src={logoTrawlpack} alt="" />
      </a>
      <div className="grid md:grid-cols-2">
        <div style={{ textAlign: "-webkit-center", margin: "20px" }}>
          <div className="my-10">
            <p className="mb-5 text-3xl md:text-[30px] text-putih font-bold">
              Kamu ingin punya usaha kargo? Tapi Modalnya kecil? <br /> <span style={{color: "yellow"}}>Kami berikan peluang!</span> Dengan potensi keuntungan hingga 50jt per bulan!
            </p>
            <a href="https://trawlben.netlify.app/mitra-space/">
              <button className="mb-5  px-4 py-2 text-putih bg-[#CD3936] rounded-xl">
                Daftar Sekarang !!!
              </button>
            </a>
            <h1 className="mb-5 text-3xl md:text-[38px] text-putih font-bold">
              Jadi Sultan Cargo <br /> Sekarang Juga !!!
            </h1>
          </div>
          <div style={{ textAlign: "-webkit-center"}} className="text-center pt-18 mb-10">
            <img
              // style={{width:"100%" , paddingTop:140}}
              src="https://media.graphassets.com/eYrGMr2hQPev3R4A4iyu"
              alt=""
            className="w-10 md:h-4/5 md:w-3/4 "
            />
          </div>
        </div>
      </div>
    </div>}


    {isTabletOrMobile &&
    <div className=" background-jasa-top-kargo-mobile">
      <a href="/" className="mb-100 m-auto">
        <img className="w-36" src={logoTrawlpack} alt="" />
      </a>
      <div className="grid md:grid-cols-2">
        <div style={{ textAlign: "-webkit-center" }}>
          <div className="">
            <p className="mb-5 text-3xl text-[15px] text-putih font-bold">
              Kamu ingin punya usaha kargo? Tapi Modalnya kecil? <br /> <span style={{color: "yellow"}}>Kami berikan peluang!</span> Dengan potensi keuntungan hingga 50jt per bulan!
            </p>
            <a href="https://trawlben.netlify.app/mitra-space/">
              <button className="mb-5  mt-2  px-4 py-1 text-putih bg-[#CD3936] rounded-xl  ">
                Daftar Sekarang !!!
              </button>
            </a>
            <h1 className="text-2xl mt-1 md:text-[15px] text-putih font-bold">
              Jadi Sultan Cargo <br /> Sekarang Juga !!!
            </h1>
          </div>
          <div style={{ textAlign: "-webkit-center" }} className="text-center">
            <img
              //  style={{width:"40%",paddingTop:10}}
              src="https://media.graphassets.com/eYrGMr2hQPev3R4A4iyu"
              alt=""
              className="md:w-10 h-4/5 w-3/4 "
            />
          </div>
        </div>
      </div>
    </div>}



    </div>
  );
};

export default Head;
